// Browser support detection utility

export interface BrowserSupport {
  webp: boolean;
  modernCSS: boolean;
  isSupported: boolean;
  browserName: string;
  browserVersion: string;
}

export const detectBrowserSupport = (): BrowserSupport => {
  // Detect WebP support
  const webpSupport = (() => {
    const canvas = document.createElement('canvas');
    canvas.width = 1;
    canvas.height = 1;
    return canvas.toDataURL('image/webp').indexOf('data:image/webp') === 0;
  })();

  // Detect modern CSS support (CSS Grid, Flexbox, etc.)
  const modernCSSSupport = (() => {
    return CSS.supports('display', 'grid') && CSS.supports('display', 'flex');
  })();

  // Browser detection
  const userAgent = navigator.userAgent;
  let browserName = 'Unknown';
  let browserVersion = 'Unknown';

  if (userAgent.includes('Chrome') && !userAgent.includes('Edg')) {
    browserName = 'Chrome';
    const match = userAgent.match(/Chrome\/(\d+)/);
    browserVersion = match ? match[1] : 'Unknown';
  } else if (userAgent.includes('Firefox')) {
    browserName = 'Firefox';
    const match = userAgent.match(/Firefox\/(\d+)/);
    browserVersion = match ? match[1] : 'Unknown';
  } else if (userAgent.includes('Safari') && !userAgent.includes('Chrome')) {
    browserName = 'Safari';
    const match = userAgent.match(/Version\/(\d+)/);
    browserVersion = match ? match[1] : 'Unknown';
  } else if (userAgent.includes('Edg')) {
    browserName = 'Edge';
    const match = userAgent.match(/Edg\/(\d+)/);
    browserVersion = match ? match[1] : 'Unknown';
  } else if (userAgent.includes('MSIE') || userAgent.includes('Trident')) {
    browserName = 'Internet Explorer';
    const match = userAgent.match(/(?:MSIE |rv:)(\d+)/);
    browserVersion = match ? match[1] : 'Unknown';
  }

  const isSupported = webpSupport && modernCSSSupport;

  return {
    webp: webpSupport,
    modernCSS: modernCSSSupport,
    isSupported,
    browserName,
    browserVersion
  };
};

export const SUPPORTED_BROWSERS = [
  { name: 'Chrome', minVersion: '32', current: true },
  { name: 'Firefox', minVersion: '65', current: true },
  { name: 'Safari', minVersion: '14', current: true },
  { name: 'Edge', minVersion: '18', current: true },
  { name: 'Opera', minVersion: '19', current: true },
];

export const UNSUPPORTED_BROWSERS = [
  { name: 'Internet Explorer', reason: 'No WebP support, outdated CSS features' },
  { name: 'Safari', version: '< 14', reason: 'Limited WebP support' },
  { name: 'Chrome', version: '< 32', reason: 'No WebP support' },
  { name: 'Firefox', version: '< 65', reason: 'Limited WebP support' },
];